import { gql } from '@/__generated__/gateway';

export const patternSuggestionsForYarnQuery = gql(`
  query PatternSuggestionsForYarn($yarnProductGroupIdentifier: ID!, $locale: String!, $cursor: String, $limit: Int) {
    crafter {
      patternSuggestionsForYarn(yarnProductGroupIdentifier: $yarnProductGroupIdentifier, locale: $locale, cursor: $cursor, limit: $limit) {
        patterns {
          name
          image {
            url
            alt
          }
          sku
        }
        cursor
        limit
      }
    }
  }
`);
